import { render } from "./BeamerUnsupportedFeatures.vue?vue&type=template&id=33eed619&ts=true"
import script from "./BeamerUnsupportedFeatures.vue?vue&type=script&lang=ts"
export * from "./BeamerUnsupportedFeatures.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__